export const primary = '#4F86C6';
export const primaryLight = '#4FB0C6';
export const primaryDark = ' #6C49B8';

export const tertiaryLight = '#0575E6';
export const tertiaryDark = '#021B79';

export const blackLight = '#152d32';
export const blackDark = '#001f24';

export const greyDark3 = '#333';

export const white = '#ffffff';
export const black = '#000000';

export const blueAnimation = '#228DFF';
